function handleScorecardSplit() {
    const el = document.querySelector('.section-scorecard-split');
    const cont = el.querySelector('#scorecard-select');
    const select = cont.querySelector('select');
    const selection = cont.querySelector('span');
    const ul = cont.querySelector('ul');
    const scorecardGroups = el.querySelectorAll('.scorecard-tees-group');

    // Show only the first scorecard on page load
    scorecardGroups.forEach((group, idx) => {
        group.style.display = idx === 0 ? 'block' : 'none';
    });

    const handleListItems = (ul, selectedItem) => {
        ul.querySelectorAll('li').forEach(l => {
            l.classList.toggle('active', l === selectedItem);
        });
    }

    const handleToggle = () => {
        ul.classList.toggle('open');
        const icon = cont.querySelector('i');
        icon.classList.toggle('flip');
    }

    cont.addEventListener('click', (e) => {
        handleToggle();

        if (e.target.localName == 'li' && e.target.dataset.value) {
            select.value = e.target.dataset.value;
            selection.innerHTML = e.target.innerHTML;
            handleListItems(ul, e.target);

            // Show the selected scorecard, hide others
            scorecardGroups.forEach(group => {
                if (group.dataset.scorecard === e.target.dataset.value) {
                    group.style.display = 'block';
                } else {
                    group.style.display = 'none';
                }
            });
        }
    });

    document.addEventListener('click', (e) => {
        if (!cont.contains(e.target) && ul.classList.contains('open')) {
            handleToggle();
        }
    });
}

if (document.querySelector('.section-scorecard-split')) {
    handleScorecardSplit();
}